<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="close" @vm-close="close" :vm-active="isModalImageVisible" :vm-title='title' :vm-show-buttons="false")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        img.image(src='@/assets/id_project.png', v-if="imageIdProject")
        img.image(src='@/assets/id_category.png', v-if="imageIdCategory")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalImage',
  props: {
    title: {
      type: String,
      default: 'Import CSV or Excel file'
    }
  },
  data () {
    return {
      file: ''
    }
  },
  computed: {
    ...mapGetters([
      'isModalImageVisible',
      'imageIdProject',
      'imageIdCategory'
    ]),
    isFile () {
      return !this.file
    }
  },
  methods: {
    ...mapActions([
      'importScopeData',
      'downloadTemplate',
      'setModalImageVisible'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    importAction () {
      this.importScopeData({ file: this.file, project_id: this.project_id })
    },
    close () {
      this.setModalImageVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.image {
    width: 100%;
    height: 100%;
    background: #e4e4e4;
    box-sizing: content-box;
}
a {
  cursor: pointer;
}
</style>
